import React from 'react';


var devices = [];

var senddevices = '';
export default class CreateEvent extends React.Component{
constructor(props){
  super(props);
  this.state = {

multiclass:false,
data:[],
eventname:'',
eventdescription:'',
eventdate:'',
timesH:'',
timesM:'',
timeeH:'',
timeeM:'',
theclasses:[],
eventvenue:'',
transportMethod:'',
amountPayable:'',
payBy:'',
collectors:[],
  }
}





componentDidMount(){
  fetch('https://schoolportal.appsdesign.co.za/get_class/' + localStorage.getItem('schoolToken'))
  .then((response) => response.json())
  .then((responseJson) => {
console.log(responseJson[0])
    this.setState({
      data: responseJson,

}, function(){

    });
console.log(this.state.data)
  })
  .catch((error) =>{
    console.error(error);
  });


  fetch('https://schoolportal.appsdesign.co.za/get_collector/' + localStorage.getItem('schoolToken'))
  .then((response) => response.json())
  .then((responseJson) => {
  console.log(responseJson[0])
    this.setState({
      collectors: responseJson,

  }, function(){

    for(let v = 0; v < this.state.collectors.length; v++){

      devices.unshift(this.state.collectors[v].token);
    }

    senddevices = devices.join('==')

    });
  console.log(this.state.data)
  })
  .catch((error) =>{
    console.error(error);
  });








  }




  createEvent = () =>{

   if(this.state.eventname === ''){

      alert(`please add event name`);
    }

    else if(this.state.eventdescription === ''){

        alert(`please add an event description`);
      }

      else if(this.state.eventvenue === ''){

          alert(`please add eventvenue`);
        }
        else if(this.state.timesH === ''){

            alert(`please add event start time`);
          }
          else if(this.state.timeeH === ''){

              alert(`please add event end time`);
            }
            else if(this.state.theclasses === []){

                alert(`please add at least 1 class`);
              }

                  else{


var stime = this.state.timesH +':'+(this.state.timesM !== '' ? this.state.timesM : '00');

var etime = this.state.timeeH +':'+(this.state.timeeM !== '' ? this.state.timeeM : '00');

                    alert(`Creating event: \n\r

                           Name: ${this.state.eventname} \n\r
                           Venue: ${this.state.eventvenue} \n\r
                           Date: ${this.state.eventdate} \n\r
                           Start time: ${stime} \n\r
                           End time: ${etime} \n\r

                           Classes: ${this.state.theclasses} \n\r

                           `);

                         fetch('https://schoolportal.appsdesign.co.za/school/createevents', {
                             method: 'post',
                             headers: {'Content-Type' : 'application/json'},
                             body: JSON.stringify({
                              school:localStorage.getItem('schoolToken'),
                               eventname:this.state.eventname,
                               eventdescription:this.state.eventdescription,
                               eventdate:this.state.eventdate,
                               eventvenue:this.state.eventvenue,
                               transportMethod:this.state.transportMethod,
                               amountPayable:this.state.amountPayable,
                               payBy:this.state.payBy,
                               startTime:stime,
                               endTime:etime,
                               theclasses:this.state.theclasses,

                       })
                         })
                         .then(fetch("https://us-central1-za-ad-fetch-my-kid.cloudfunctions.net/addMessage?text="+senddevices+"&title="+localStorage.getItem('schoolToken')+"&bodyn="+ this.state.eventdescription))
                         .then(response =>{
                           this.setState({
                             eventname:'',
                             eventdescription:'',
                             eventdate:'',
                             eventvenue:'',
                             timesH:'',
                             timesM:'',
                             timeeH:'',
                             timeeM:'',
                             theclasses:[],
                           },function(){

                             var elements = document.getElementsByTagName("input");
                             for (var ii=0; ii < elements.length; ii++) {
                               if (elements[ii].type === "textarea" || elements[ii].type === "text" || elements[ii].type === "select" || elements[ii].type === "date") {
                                 elements[ii].value = "";
                               }
                             }

                              alert('The Event /  Activity has been created')


                            })


                        })


.catch((err) => alert('there was an error' + err ))



                  }


  }


































  onChangeClasses = (event) =>{

if(event.target.value !== ""){
  var theclasses = this.state.theclasses;


  theclasses.unshift(event.target.value);

  this.setState({theclasses:theclasses})


}
else{
  return
}
  }

  onRemoveClass = (val) =>{

    var theclasses = this.state.theclasses;


    theclasses.splice(val);


  this.setState({theclasses:theclasses});

  }


render(){

  const schoolclasses = this.state.data.map((schoolclass, i) => {

  return(

    <option key={i} value={schoolclass.assClass}>{schoolclass.assClass}</option>
  )


  });





  const addedclasses = this.state.theclasses.map((val,i) =>{

    return (
      <div key={i} style={{display: 'flex', justifyContent:'space-between', border:'1px solid black', width:100}}>
      <span style={{color:'black', fontWeight:'bold'}}>{val}</span>
       <button onClick={() => this.onRemoveClass(i)}>&times;</button>
       </div>


)
  })



  return(




    <div className="ma2 pa2 br3 shadow-4"
    style={{display:'flex', flexDirection:'column',justifyContent:'space-evenly',  margin:100,backgroundColor:'white'}}>


<h1>Enter event/activity details</h1>



    <label htmlFor="eventname" style={{marginRight:21}}>
    Event / Activity Name
    <input
    type="text"
    placeholder="Event/Activity Name"
    id="eventname"
    className="pa2 ma2"
    onKeyUp={(event) => this.setState({eventname:event.target.value})}
    /></label>
    <br/>



    <label htmlFor="eventdescription" style={{marginRight:21}}>
    Event /Activity Description<br/>
    <textarea
    type="text"
    style={{width:'60%'}}
    placeholder="Describe the event / activity"
    id="eventdescription"
    className="pa2 ma2"
    onKeyUp={(event) => this.setState({eventdescription:event.target.value})}
    /></label>
    <br/>


    <label htmlFor="eventvenue" style={{marginRight:21}}>
    Event / Activity Venue
    <input
    type="text"
    placeholder="Event/Activity Venue"
    id="eventvenue"
    className="pa2 ma2"
    onKeyUp={(event) => this.setState({eventvenue:event.target.value})}
    /></label>
    <br/>



    <label htmlFor="eventdate" style={{marginRight:21}}>
    Event / Activity Date
    <input
    type="date"
    placeholder="Event/Activity Date"
    id="eventdate"
    className="pa2 ma2"
    onChange={(event) => this.setState({eventdate:event.target.value})}
    /></label>
    <br/>



            <label htmlFor="childCategory">
            Time Start
          <select
          id="childCategory"
          className="pa2 ma2"
          onChange={(event) => this.setState({timesH:event.target.value})}

            >

                    <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                        <option value="10">10</option>

                        <option value="11">11</option>
                          <option value="12">12</option>
                            <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>


                </select>
                :
                <select
                id="childCategory"
                className="pa2 ma2"
                onChange={(event) => this.setState({timesM:event.target.value})}
                  >
                  <option value="01">01</option>
                  <option value="02">02</option>
                    <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                        <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                      <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                          <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>

                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                                <option value="23">23</option>
                                  <option value="24">24</option>
                                  <option value="25">25</option>
                                    <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                  <option value="30">30</option>
                                    <option value="31">31</option>
                                    <option value="32">32</option>
                                      <option value="33">33</option>
                                        <option value="34">34</option>
                                        <option value="35">35</option>
                                          <option value="36">36</option>
                                          <option value="37">37</option>
                                          <option value="38">38</option>
                                          <option value="39">39</option>

                                          <option value="40">40</option>
                                          <option value="41">41</option>
                                          <option value="42">42</option>
                                            <option value="43">43</option>
                                              <option value="44">44</option>
                                              <option value="45">45</option>
                                                <option value="46">46</option>
                                            <option value="47">47</option>
                                            <option value="48">48</option>
                                            <option value="49">49</option>
                                              <option value="50">50</option>
                                                <option value="51">51</option>
                                                <option value="52">52</option>
                                                  <option value="53">53</option>
                                                    <option value="54">54</option>
                                                    <option value="55">55</option>
                                                      <option value="56">56</option>
                                                      <option value="57">57</option>
                                                      <option value="58">58</option>
                                                      <option value="59">59</option>



                      </select>
            </label><br/>

            <label htmlFor="childCategory">
            Time End
          <select
          id="childCategory"
          className="pa2 ma2"
            onChange={(event) => this.setState({timeeH:event.target.value})}
            >

                    <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                        <option value="10">10</option>

                        <option value="11">11</option>
                          <option value="12">12</option>
                            <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="15">15</option>
                                <option value="16">16</option>
                                <option value="17">17</option>
                                <option value="18">18</option>
                                <option value="19">19</option>


                </select>
                :
                <select
                id="childCategory"
                className="pa2 ma2"
                onChange={(event) => this.setState({timeeM:event.target.value})}
                  >
                  <option value="01">01</option>
                  <option value="02">02</option>
                    <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                        <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                      <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                          <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                              <option value="16">16</option>
                              <option value="17">17</option>
                              <option value="18">18</option>
                              <option value="19">19</option>

                              <option value="20">20</option>
                              <option value="21">21</option>
                              <option value="22">22</option>
                                <option value="23">23</option>
                                  <option value="24">24</option>
                                  <option value="25">25</option>
                                    <option value="26">26</option>
                                <option value="27">27</option>
                                <option value="28">28</option>
                                <option value="29">29</option>
                                  <option value="30">30</option>
                                    <option value="31">31</option>
                                    <option value="32">32</option>
                                      <option value="33">33</option>
                                        <option value="34">34</option>
                                        <option value="35">35</option>
                                          <option value="36">36</option>
                                          <option value="37">37</option>
                                          <option value="38">38</option>
                                          <option value="39">39</option>

                                          <option value="40">40</option>
                                          <option value="41">41</option>
                                          <option value="42">42</option>
                                            <option value="43">43</option>
                                              <option value="44">44</option>
                                              <option value="45">45</option>
                                                <option value="46">46</option>
                                            <option value="47">47</option>
                                            <option value="48">48</option>
                                            <option value="49">49</option>
                                              <option value="50">50</option>
                                                <option value="51">51</option>
                                                <option value="52">52</option>
                                                  <option value="53">53</option>
                                                    <option value="54">54</option>
                                                    <option value="55">55</option>
                                                      <option value="56">56</option>
                                                      <option value="57">57</option>
                                                      <option value="58">58</option>
                                                      <option value="59">59</option>



                      </select>
            </label><br/>



              <p><strong>Select classes for this activity/event.<br/>
              To Select Multiple Classes: press button and hold down the ctrl (Windows) or cmd (Mac) button to select more than one.</strong></p>
<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
{addedclasses}
</div>
              <label htmlFor="childCategory">
              Add Classes
              <select
              multiple={this.state.multiclass}
              onChange={(value) => this.onChangeClasses(value)}
              >
              <option value="">Please select class/classes</option>
              {schoolclasses}
               </select>

              <button className="br3 ma3 pa3 bg-blue br-blue" onClick={() => this.setState({multiclass:!this.state.multiclass ? true : false})}>select multiple</button>
</label><br/>






<label htmlFor="transportmethod" style={{marginRight:21}}>
Transport Method
<input
type="text"
placeholder="Transport Method"
id="transportmethod"
className="pa2 ma2"
onKeyUp={(event) => this.setState({transportMethod: event.target.value})}
/></label>
<br/>

<div>
<label htmlFor="amountpayable" style={{marginRight:21}}>
Amount Payable
<input
type="text"
placeholder="Amount Payable"
id="amountpayable"
className="pa2 ma2"
onKeyUp={(event) => this.setState({amountPayable:'R' + event.target.value})}
/></label>



<label htmlFor="payby" style={{marginRight:21}}>
Pay By
<input
type="date"
placeholder="Enter last day to pay"
id="payby"
className="pa2 ma2"
onChange={(event) => this.setState({payBy:event.target.value})}
/></label>
<br/>


                <button className="br3 ma3 pa3 bg-blue br-blue" onClick={this.createEvent}>Create Event / Activity</button>
</div>
</div>





  )
}

}



// WEBPACK FOOTER //
// ./src/components/FMK-EVENTS/CreateEvent.js